import UserClient from '@/api/UserClient';
import { toCamelCase } from '@/utilities';

const userPreferencesKey = 'user_preferences';
export default {
  namespaced: true,
  state: {
    minimizedHeader: false,
    showingSettingsDropdownMenu: false,
    cardSwitcherPreference: null,
    hideLoginNavSection: false,
    disableExitButton: false,
    searchBarFocused: false,
    addressTimeslotPanelDismissed: false,
  },
  mutations: {
    setMinimizedHeader(state, value) {
      state.minimizedHeader = value;
    },
    setShowingSettingsDropdownMenu(state, value) {
      state.showingSettingsDropdownMenu = value;
    },
    setCardSwitcherPreference(state, value) {
      state.cardSwitcherPreference = value;
    },
    setHideLoginNavSection(state, value) {
      state.hideLoginNavSection = value;
    },
    setDisableExitButton(state, value) {
      state.disableExitButton = value;
    },
    setSearchBarFocused(state, value) {
      state.searchBarFocused = value;
    },
    setAddressTimeslotPanelDismissed(state, value) {
      state.addressTimeslotPanelDismissed = value;
    },
  },
  actions: {
    updateMinimizedHeader({ commit }, value) {
      commit('setMinimizedHeader', value);
    },
    updateShowingSettingsDropdownMenu({ commit }, value) {
      commit('setShowingSettingsDropdownMenu', value);
    },
    async getCardSwitcherPreference({ rootState, commit }) {
      const userClient = new UserClient(rootState.authorization.user);
      const { data: { data: { [userPreferencesKey]: result } } } = await userClient
        .getKeyValueStoreItem(toCamelCase(userPreferencesKey));
      const { listView } = JSON.parse(result);
      commit('setCardSwitcherPreference', listView || 'horizontal');
    },
    async updateCardSwitcherPreference({ rootState, commit }, value) {
      const userClient = new UserClient(rootState.authorization.user);
      const listViewObj = {
        listView: value,
      };
      await userClient.putKeyValueStoreItem(
        toCamelCase(userPreferencesKey),
        JSON.stringify(listViewObj),
      );
      commit('setCardSwitcherPreference', value);
    },
    clearCardSwitcherPreference({ commit }) {
      commit('setCardSwitcherPreference', null);
    },
    updateHideLoginNavSection({ commit }, value) {
      commit('setHideLoginNavSection', value);
    },
    updateDisableExitButton({ commit }, value) {
      commit('setDisableExitButton', value);
    },
    updateSearchBarFocused({ commit }, value) {
      commit('setSearchBarFocused', value);
    },
    updateAddressTimeslotPanelDismissed({ commit }, value) {
      commit('setAddressTimeslotPanelDismissed', value);
    },
  },
  getters: {
    minimizedHeader: (state) => state.minimizedHeader,
    showingSettingsDropdownMenu: (state) => state.showingSettingsDropdownMenu,
    verticalCardPreference: (state) => state.cardSwitcherPreference === 'vertical',
    hideLoginNavSection: (state) => state.hideLoginNavSection,
    disableExitButton: (state) => state.disableExitButton,
    searchBarFocused: (state) => state.searchBarFocused,
    addressTimeslotPanelDismissed: (state) => state.addressTimeslotPanelDismissed,
  },
};
